<template>
  <div class="word_4"  ref="previewDom">
    
    <div class="a4">
      <div class="th">
        <div class="box box-lable" style="width:120px;height:70px;line-height:70px">工种类别</div>
        <div class="box" style="width:250px;height:70px;text-align:start;padding-left:10px">
          {{alldata.info.type_of_work}}
        </div>
        <div class="box box-lable" style="width:160px;height:70px;line-height:70px">专业分类</div>
        <div class="box" style="width:191px;height:70px">{{alldata.info.type_of_major}}</div>
      </div>
	  
	  <div class="th">
	    <div class="box box-lable" style="width:120px;height:60px;line-height:60px">工法名称</div>
	    <div class="box" style="width:599px;height:60px">{{alldata.info.name}}</div>
	  </div>
	  <div class="th">
	    <div class="box box-lable" style="width:120px;height:60px;line-height:60px">编写单位</div>
	    <div class="box" style="width:599px;height:60px">{{alldata.info.unit}} {{alldata.info.gf_province == 1 ? '省内' : '省外'}}</div>
	  </div>
	  <div class="th">
		<div class="box box-lable" style="width:120px;height:70px;line-height:70px">联系人</div>
		<div class="box" style="width:250px;height:70px;text-align:start;padding-left:10px">
		  {{alldata.info.username}}
		</div>
		<div class="box box-lable" style="width:160px;height:70px;line-height:70px">电话</div>
		<div class="box" style="width:191px;height:70px">{{alldata.info.phone || alldata.info.tel}}</div>
	  </div>
	  <div class="th">
	    <div class="box box-lable" style="width:120px;height:60px;line-height:60px">主要完成人</div>
	    <div class="box" style="width:599px;height:60px">{{ authorNames }}</div>
	  </div>
	  <div class="th-1" style="margin-top: 30px;">
	    <div class="box-1 gf-file-grid" style="width:719px;height:60px">
			<div class="col col-2 gf-file-col gf-file-col-wide">贵州省级工法申报汇总表（附件2）</div>
			<div class="col col-1 gf-file-col">贵州省级工法申报表(附件1)</div>
			<div class="col col-1 gf-file-col">工法申报承诺书</div>
			<div class="col col-1 gf-file-col">工法文本</div>
			<div class="col col-1 gf-file-col">企业工法证明材料</div>
			<div class="col col-3 gf-file-col">工法关键技术专家论证的有关资料</div>
		</div>
	    <div class="box-1 gf-file-grid" style="width:719px;height:60px">
			<div class="col-txt col-txt-1 gf-file-col-txt">
				<div class="txt-lab">盖章PDF</div>
				<a v-if="alldata.info.filelist1&&alldata.info.filelist1[0]" class="txt-see" target="_blank" :href="alldata.info.filelist1[0].url">查看</a>
				<a v-else class="txt-see" target="_blank" ></a>
			</div>
			<div class="col-txt col-txt-1 gf-file-col-txt">
				<a v-if="alldata.info.filelist2&&alldata.info.filelist2[0]" class="txt-see" target="_blank" :href="alldata.info.filelist2[0].url">查看</a>
				<a v-else class="txt-see" target="_blank" ></a>
			</div>
			<div class="col-txt col-txt-1 gf-file-col-txt">
				<a v-if="alldata.info.filelist3&&alldata.info.filelist3[0]" class="txt-see" target="_blank" :href="alldata.info.filelist3[0].url">查看</a>
				<a v-else class="txt-see" target="_blank" ></a>
			</div>
			<div class="col-txt col-txt-1 gf-file-col-txt">
				<a v-if="alldata.info.filelist_commitment&&alldata.info.filelist_commitment[0]" class="txt-see" target="_blank" :href="alldata.info.filelist_commitment[0].url">查看</a>
				<a v-else class="txt-see" target="_blank" ></a>
			</div>
			<div class="col-txt col-txt-1 gf-file-col-txt">
				<a v-if="canViewGfText && alldata.info.filelist4&&alldata.info.filelist4[0]" class="txt-see" target="_blank" :href="alldata.info.filelist4[0].url">查看</a>
				<span v-else-if="isPublicView && !canViewGfText" class="txt-muted">未授权公开</span>
				<a v-else class="txt-see" target="_blank" ></a>
			</div>
			<div class="col-txt col-txt-1 gf-file-col-txt">
				<a v-if="alldata.info.filelist5&&alldata.info.filelist5[0]" class="txt-see" target="_blank" :href="alldata.info.filelist5[0].url">查看</a>
				<a v-else class="txt-see" target="_blank" ></a>
			</div>
			<div class="col-txt col-txt-3 gf-file-col-txt">
				<a v-if="alldata.info.filelist6&&alldata.info.filelist6[0]" class="txt-see" target="_blank" :href="alldata.info.filelist6[0].url">查看</a>
				<a v-else class="txt-see" target="_blank" ></a>
			</div>
		</div>
	  </div>
	  
	  <div class="th-1" style="margin-top: 30px;">
	    <div class="box-1" style="width:719px;">
	  			<div class="col col-1">工程应用证明</div>
	  			<div class="col col-1">经济效益证明</div>
	  			<div class="col col-1">科技查新报告</div>
	  			<div class="col col-1">涉及他方专利的无争议声明书</div>
	  			<div class="col col-1">关键技术标准、专利证书、科技成果获奖证明等其他有关材料</div>
	  			<div class="col col-3">工法应用的有关照片</div>
	  		</div>
	    <div class="box-1" style="width:719px;height:60px">
	  			<div class="col-txt col-txt-1">
					<a v-if="alldata.info.filelist7&&alldata.info.filelist7[0]" class="txt-see" target="_blank" :href="alldata.info.filelist7[0].url">查看</a>
					<a v-else class="txt-see" target="_blank" ></a>
				</div>
	  			<div class="col-txt col-txt-1">
					<a v-if="alldata.info.filelist8&&alldata.info.filelist8[0]" class="txt-see" target="_blank" :href="alldata.info.filelist8[0].url">查看</a>
					<a v-else class="txt-see" target="_blank" ></a>
				</div>
	  			<div class="col-txt col-txt-1">
					<a v-if="alldata.info.filelist9&&alldata.info.filelist9[0]" class="txt-see" target="_blank" :href="alldata.info.filelist9[0].url">查看</a>
					<a v-else class="txt-see" target="_blank" ></a>
				</div>
	  			<div class="col-txt col-txt-1">
					<a v-if="alldata.info.filelist10&&alldata.info.filelist10[0]" class="txt-see" target="_blank" :href="alldata.info.filelist10[0].url">查看</a>
					<a v-else class="txt-see" target="_blank" ></a>
				</div>
	  			<div class="col-txt col-txt-1">
					<a v-if="alldata.info.filelist11&&alldata.info.filelist11[0]" class="txt-see" target="_blank" :href="alldata.info.filelist11[0].url">查看</a>
					<a v-else class="txt-see" target="_blank" ></a>
	  			</div>
	  			<div class="col-txt col-txt-3">
					<el-button v-if="alldata.info.filelist12" type="text" class="txt-see txt-img"   @click="dialogTableVisible = true">查看</el-button>
					<!-- <a v-if="alldata.info.filelist12[0]" class="txt-see" target="_blank" :href="alldata.info.filelist12">查看</a> -->
	  			<el-dialog  title="工法应用的有关照片" :visible.sync="dialogTableVisible" center="true">
					<div v-if="alldata.info.filelist12" v-for="item in alldata.info.filelist12">
						<div v-if="isVideo(item['name'])" class="demo-image__lazy" >
							<video width="820" >
								<source :src="item['url']" type="video/mp4">
								<source :src="item['url']" type="video/ogg">
								您的浏览器不支持Video标签。
							</video>
							<div style="padding:20px; text-align:center">
								<a :href="item['url']" target="_blank" rel="noopener noreferrer">打开新窗口播放</a>
							</div>
						</div>
						<div v-else class="demo-image__lazy" >
							<el-image  :key="item['url']" :src="item['url']" lazy></el-image>
						</div>
					</div>
					<a v-else class="txt-see" target="_blank" ></a>
	  			</el-dialog>
				</div>
	  		</div>
	  </div>
	  
    </div>
  </div>
  
</template>


<script>
import self_adaption from './adaption'
export default {
  props: {
	dialogTableVisible:{
		type:Boolean,
		default:false,
	},
    alldata: {
      type: Object,
      default: {},
      year:""
    },
    isPublicView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    canViewGfText() {
      if (!this.isPublicView) {
        return true;
      }
      const info = (this.alldata && this.alldata.info) || {};
      return this.isAuthorized(info.text_public_authorized)
        || this.isAuthorized(info.gf_text_authorized)
        || this.isAuthorized(info.textPublicAuthorized)
        || this.isAuthorized(this.alldata && this.alldata.text_public_authorized)
        || this.isAuthorized(this.alldata && this.alldata.gf_text_authorized);
    },
    authorNames() {
      let authors = (this.alldata && this.alldata.info && this.alldata.info.author_names) || [];
      if (typeof authors === 'string') {
        try {
          authors = JSON.parse(authors);
        } catch (e) {
          authors = authors.split(/[、,，]/);
        }
      }
      if (!Array.isArray(authors)) {
        authors = Object.values(authors || {});
      }
      const names = authors
        .map(author => typeof author === 'string' ? author : (author && author.name))
        .map(name => String(name || '').trim())
        .filter(Boolean);
      return names.length ? names.join('、') : '-';
    },
  },
  data() {
    return {
      xiahuaxian:
        "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
    };
  },
  mounted() {
    self_adaption()
    this.$emit('previewDom',this.$refs.previewDom)//整页DOM上传至父组件
  },
  methods:{
    isAuthorized(value) {
      return value === true || value === 1 || value === '1';
    },
	isVideo(name) {
		return this.checkFile(name, 'video')
	},
    checkFile(fileValue,type) {
      console.log("fileValue==" + fileValue);
      var index = fileValue.indexOf("."); //（考虑严谨用lastIndexOf(".")得到）得到"."在第几位
      var fileValueSuffix = fileValue.substring(index); //截断"."之前的，得到后缀
      if(type == 'video') { // .mp4,.avi,.flv
          if (!/(.*)\.(mp4|rmvb|flv|avi)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合视频格式
              return false;
          }
      }
      if(type == 'image') {
          if (!/(.*)\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合图片格式
              return false;
          }
      }
  
      return true;
    },
  }
};
</script>

<style lang="less" scoped>
.a4 {
  padding: 50px 60px 50px 60px;
  width: 842px;
  // height: 1346px;
  min-height: 719px;
  height: 719px;
  margin: 0 auto;
  margin-top: 32px;
  background: #ffffff;
  box-sizing: border-box;
  color: black;
  box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.16);
  margin-bottom: 100px;
  p,
  h1 {
    font-family: "仿宋";
  }
  .th {
    display: flex;
    align-items: center;
    font-family: "仿宋";
	justify-content: center;
  }
  .box {
    box-sizing: border-box;
    border: 1px solid #D4DBDD;
    margin: 0 -1px -1px 0;
    text-align: center;
    font-size: 14px;
	font-weight: bold;
	display: flex;
	justify-content: center;
	align-items: center;
  }
  .th-1{
    // display: flex;
    // align-items: center;
    font-family: "仿宋";
  }
  .box-lable{
	background-color: #F5F9FB;
	color: #194ABE;
	font-weight: 400;
  }
  .box-1 {
    box-sizing: border-box;
    border: 1px solid #D4DBDD;
    margin: 0 -1px -1px 0;
    font-size: 14px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #194ABE;
  }
  .col{
	width: 120px;
	margin: 8px;
	background-color: #F5F9FB;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 400;
  }
  .col-1{
	width: 119px;
	border-right: 1px solid #D4DBDD;
  }
  .col-2{
	width: 238px;
	border-right: 1px solid #D4DBDD;
  }
  .col-3{
	width: 120px;
  }
  
  .col-txt{
	width: 119px;
	height: 58px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: #333333;
  }
  .col-txt-1{
	width: 119px;
	border-right: 1px solid #D4DBDD;
  }
  .col-txt-2{
	width: 238px;
	border-right: 1px solid #D4DBDD;
  }
  .col-txt-3{
    width: 120px;
  }

  .gf-file-col {
    flex: 1;
    min-width: 0;
    width: auto;
    margin-left: 4px;
    margin-right: 4px;
  }
  .gf-file-col-wide {
    flex: 2;
  }
  .gf-file-col-txt {
    flex: 1;
    min-width: 0;
    width: auto;
  }
  .txt-lab{
	  color: #7C828A;
	  margin-bottom: 2px;
  }
  .txt-see{
	  font-weight: bold;
	  color: #333333;
	  cursor: pointer;
	  text-decoration: underline;
  }
  .txt-img{
	  color: #194ABE;
  }
  .txt-see:link{
	  color: #194ABE;
  }
  .txt-see:visited{ 
	  color: #194ABE;
  }
  .txt-see:hover{
	  color: #194ABE;
  }
  .txt-muted{
	  color: #7C828A;
	  font-size: 12px;
  }
}
</style>
